import React from 'react'
import './../ui.style.scss'

const PartnerHeading = ({ title, active }) => {
  return (
    <div className='partner-heading'>
      <p> { title }</p>
      <p className={`status ${active ? 'active' : 'inActive'}`}> { active ? 'Active' : 'InActive' }</p>
    </div>
  )
}

PartnerHeading.propTypes = {

}

PartnerHeading.defaultProps = {
  title: 'Partner',
  status: 'Active'
}

export default PartnerHeading
